import axios from 'axios';

/**
 * 获取客户列表
 *
 * @param {*} params
 * @param {string} key      授权Token
 * @param {string} order    筛选 transaction_money
 * @param {number} isasc    升降序 0-降序 1-升序
 * @param {string} type     筛选关键字 1-客户 2-供应商 0-客户、供货商 默认为客户
 * @param {number} vip      客户等级
 * @param {number} page	    页码
 * @param {number} page_num 条数/页
 */
export function requestCustomerList(params) {
  return axios.post('/customer/get_by_order', params);
}
/**
 * 搜索客户
 *
 * @param {*} params
 * @param {string} key      授权 Token
 * @param {string} order    排序
 * @param {number} isasc    升降序 0-降序 1-升序
 * @param {string} vip      客户等级
 * @param {string} type     搜索 company_name 按名称搜索 address 按地址搜索
 * @param {string} keyword  关键词
 * @param {string} client_type 筛选关键字 1-客户 2-供应商 0-客户、供货商 默认为客户
 * @param {string} mask_openid 传空为搜索未关联 all搜索所有 具体值为搜索关联openid为该值的客户或供货商 默认all
 * @param {number} shop_id  店铺
 * @param {number} page	    页码
 * @param {number} page_num 条数/页
 */
export function requestCustomerSearch(params) {
  return axios.post('/customer/search', params);
}
/**
 * 删除客户
 *
 * @param {*} params
 * @param {string} key  授权 Token
 * @param {string} cid  客户 ID
 */
export function requestCustomerDelete(params) {
  return axios.post('/customer/del', params);
}
/**
 * 批量删除客户
 *
 * @param {*} params
 * @param {string} key        授权 Token
 * @param {array}  client_ids 客户 ID 数组
 */
export function requestCustomerDeleteBatch(params) {
  return axios.post('/customer/batch_del', params);
}
/**
 * 批量设置客户属性
 *
 * @param {*} params
 * @param {string} key        授权 Token
 * @param {number} quantity   选中数量
 * @param {string} filter     修改属性 JSON
 * @param {string} attribute  把选中的项属性修改为 attribute 中的数据
 */
export function requestCustomerAttrBatch(params) {
  return axios.post('/customer/batch_set_attribute', params);
}

export function requestBatchAdd(params) {
  return axios.post('/customer/import_v1', params, { needResponse: 1 });
}

/**
 * 客户导出
 *
 * @param {*} params
 * @param {string} key      授权 Token  responseType: 'blob'
 */
export function requestExportCustomer(params) {
  return axios.get('/report/export_client', { responseType: 'blob', params: params });
}

// 获取客户信息
export function requestCustomerInfo(params) {
  return axios.get('/customer/get', { params });
}

// 获取员工列表
export function requestStaffList(params) {
  return axios.get('/user/get_staff_list', { params });
}
